<div class="desktop-container">
    <div>
        <span class="intro">
            @if (task ; as task) {
                <div>
                    <h3 class="p-0 m-0">{{ task.title }}</h3>
                    <p> Due Date <b>{{dateUtils.formatDateWithConditionalYear(task.targetDate) }}.</b> Status: <b>{{ task.status }}</b></p>
                </div>
                    
            }
        </span>
 
    </div>
    <div class="form-type type-task">
        Task
    </div>
    <app-flight-card-cta class="w-full" [flight]="task" [type]="'task'" [isEditable]="showEdit" [canBeArchived]="true"></app-flight-card-cta>
</div>

<div class="mobile-container" (click)="$event.stopPropagation()">
  <app-combined-task-card-mobile
    [data]="task"
    [type]="'task'"
    [showEdit]="showEdit"
  ></app-combined-task-card-mobile>
</div>

